import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import CardHeader from '@fingo/lib/components/headers/CardHeader';
import CardFooter from '@fingo/lib/components/footers/CardFooter';
import KeyValueStack from '@fingo/lib/components/stacks/KeyValueStack';
import ConditionalBorderStack from '@fingo/lib/components/stacks/ConditionalBorderStack';

const DesktopCredentialsCard = ({
  id,
  title,
  subtitle,
  isValid,
  credentials,
  errorMessage,
  toggle,
}) => (
  <ConditionalBorderStack id={id} showBorder={!isValid} onConditionalClick={toggle}>
    <CardHeader status={isValid} primaryText={title} />
    <Typography px={3} mb={1} flexGrow={1}>
      {subtitle}
    </Typography>
    <CardFooter id={id} errorMessage={errorMessage} success={isValid} onActionClick={toggle}>
      <KeyValueStack items={credentials} />
    </CardFooter>
  </ConditionalBorderStack>
);

DesktopCredentialsCard.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  isValid: PropTypes.bool.isRequired,
  credentials: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  errorMessage: PropTypes.string.isRequired,
  toggle: PropTypes.func,
};

DesktopCredentialsCard.defaultProps = {
  credentials: [],
  subtitle: '',
  toggle: null,
};

export default DesktopCredentialsCard;
